import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/whiteLabelSettings";

import WhiteLabelSettingsService from "../services/whiteLabelSettings";

class PhysioVideoDisplay extends Component {
  constructor(props) {
    super(props);

    let videoId = this.props.match.params.videoId;
    let extensionId = this.props.match.params.extensionId;

    //videoId = "a49bddb1191be4c02c";
   // extensionId = "f921c2899cd56acd";

    this.state = {
      videoUrl: `https://videos.sproutvideo.com/embed/${videoId}/${extensionId}?type=sd`,
    };
  }

  render() {
    return (
      <div>
        <iframe
          class="sproutvideo-player"
          title="Physio PT Video"
          src={this.state.videoUrl}
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PhysioVideoDisplay);



// WEBPACK FOOTER //
// ./src/layout/PhysioVideoDisplay.js